import type { ComponentProps } from "react";
import type { Code } from "@/app/_components/icons";

type Tokens = ComponentProps<typeof Code>["tokens"];

// Minimal Python highlighter for the quickstart snippets — covers what the
// API examples need: strings, comments, keywords, and function calls.
// Snippets stay plain strings; this converts them to Code's token format.
const PATTERN =
  /("(?:[^"\\]|\\.)*")|('(?:[^'\\]|\\.)*')|(#.*$)|\b(import|from|as|for|in|print|def|return|with|if|elif|else|not|and|or)\b|([A-Za-z_][\w.]*)(?=\()/gm;

export const pythonTokens = (source: string): Tokens => {
  const tokens: Tokens = [];
  let lastIndex = 0;
  for (const match of source.matchAll(PATTERN)) {
    const index = match.index ?? 0;
    if (index > lastIndex) tokens.push(source.slice(lastIndex, index));
    const [text, doubleQuoted, singleQuoted, comment, keyword, fn] = match;
    if (doubleQuoted || singleQuoted) tokens.push(["s", text]);
    else if (comment) tokens.push(["c", text]);
    else if (keyword) tokens.push(["k", text]);
    else if (fn) tokens.push(["f", text]);
    lastIndex = index + text.length;
  }
  if (lastIndex < source.length) tokens.push(source.slice(lastIndex));
  return tokens;
};
